import { DEFAULT_LANGUAGE } from '~/modules/config';
import { i18nStore } from '../stores/i18nStore';

export function convertToMoment(dateString: string, language: string = DEFAULT_LANGUAGE): string {
    const msPerMinute = 60 * 1000;
    const msPerHour = msPerMinute * 60;
    const msPerDay = msPerHour * 24;
    const msPerMonth = msPerDay * 30;
    const msPerYear = msPerDay * 365;

    const timestamp = new Date(dateString).getTime();
    const current = Date.now();
    const elapsed = current - timestamp;

    // TODO: Replace text for labels
    const rtf = new Intl.RelativeTimeFormat(language, { numeric: 'always' });
    if (elapsed < msPerMinute) {
        return rtf.format(-Math.floor(elapsed / 1000), 'seconds');
    } else if (elapsed < msPerHour) {
        return rtf.format(-Math.floor(elapsed / msPerMinute), 'minutes');
    } else if (elapsed < msPerDay) {
        return rtf.format(-Math.floor(elapsed / msPerHour), 'hours');
    } else if (elapsed < msPerMonth) {
        return rtf.format(-Math.floor(elapsed / msPerDay), 'days');
    } else if (elapsed < msPerYear) {
        return rtf.format(-Math.floor(elapsed / msPerMonth), 'months');
    }
    // TODO: Review when ago is longer than one year
    return new Date(timestamp).toLocaleDateString();
}

/**
 * Returns a localized string representation of a date in the format DD/MM/YYYY.
 * If the input date string is invalid or empty, returns an empty string.
 */
export function printDateSimple(dateString?: string): string {
    if (!dateString) {
        return '';
    }

    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
        return '';
    }

    const i18n = i18nStore.getState().i18n.shared;
    const day = date.getUTCDate().toString().padStart(2, '0');
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    const year = date.getUTCFullYear().toString();
    return i18n.dateSimple({ DD: day, MM: month, YYYY: year });
}

/**
 * Calculates the number of days since the user's signup date.
 * Returns the number of days since signup, or 0 if no signup date or invalid date.
 */
export function getDaysSinceSignup(signupDate?: string): number {
    if (!signupDate) {
        return 0;
    }

    const signup = new Date(signupDate);
    if (isNaN(signup.getTime())) {
        return 0;
    }

    const now = new Date();
    const diffTime = now.getTime() - signup.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
}
